var _Object = Object;

export default _Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};


// WEBPACK FOOTER //
// ./node_modules/emoji-mart/dist-es/polyfills/extends.js